<!-- <div class="custombg fixed-top">
  <app-header></app-header>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item active " (click)="gotoHome()">Home &nbsp;</li>
      <li class="breadcrumb-item active" style="cursor:pointer" (click)="switchDeckView()">KMS Portal &nbsp;</li>
      <li class="breadcrumb-item active ">Project Content</li>
    </ol>
  </nav>

</div> -->
<!---List of Users-->
<div class="wrapper">

  <div class="container mr-0">
    <div class="row" align="right">
      <div class="col-12 p-2 mt-2 style">
        <div class="btn-group add-project style">
          <button type="button" class="btn btn-secondary dropdown-toggle w-100 add-btn" id="dropdownMenuReference"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fas fa-plus"></i> Add Content
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuReference">
            <a class="dropdown-item" (click)="onChangeProjectType('Case Studies')">Case Studies</a>
            <a class="dropdown-item" (click)="onChangeProjectType('Corporate Deck')">Others</a>
          </div>
        </div>


        <div class="btn-group add-project">
          <div class="btn-group add-project style">
            <button type="button" class="btn btn-secondary dropdown-toggle w-100 add-btn" id="dropdownMenuReference"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-plus"></i> Bulk Upload
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuReference">
              <a class="dropdown-item" (click)="excelFile1.click()">Case Studies</a>
              <a class="dropdown-item" (click)="excelFile2.click()">Others</a>
              <input style="display: none;" type="file" id="excelFile1"
                (change)="handleFileInput($event.target.files, 'Case Studies')" #excelFile1 />
              <input style="display: none;" type="file" id="excelFile2"
                (change)="handleFileInput($event.target.files, 'Others')" #excelFile2 />
            </div>
          </div>


        </div>

      </div>
    </div>
  </div>
  <div class="modal-container">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-12 col-xl-12 p-2 mt-2 ">
        <div class="card margin-bottom-to-footer">
          <!---Title-->
          <div class="row d-flex p-3 m-0 border-bottom">
            <div class="heading_1  mr-auto ">Project Content</div>
            <div class="mr-3 mt-2">
              <input type="checkbox" style="height: 17px; width: 17px;cursor: pointer;" [checked]="isSelectAll"
                (change)="selectAll($event)"> &nbsp;&nbsp;<span style="font-size:large;font-weight: 400;">Select
                All</span>
            </div>
            <div class="heading_1 mr-3  mb-sm-3 mb-md-3 ">
              <select class="form-control" #type (change)="onChangeContentType(type.value)" [value]="contentType"
                [ngModel]="contentType">
                <option *ngFor="let contentTypeOption of contentTypes" [value]="contentTypeOption">{{ contentTypeOption
                  }}</option>
              </select>
            </div>
            <div *ngIf='userRole == "SuperAdmin" && contentType == "Case Studies" '>
              <!-- Org DropDown -->
              <div class="dropdown mr-2" *ngIf="organizations && this.userRole == 'SuperAdmin'">
                <select class="form-control" #org (change)="onChangeOrganization(org.value)"
                  [value]="selectedorganization?.id">
                  <option *ngFor="let organization of organizations" [value]="organization.id">{{organization.name}}
                  </option>
                </select>
              </div>
            </div>

            <div class=" d-flex input-group">
              <input class="form-control" style="border-right: none;" #searchTerm [(ngModel)]="searchText"
                (keyup.enter)="searchGrid()" id="myInput" type="text" placeholder="Search Project Content.."
                [formControl]="search" (keydown)="onKeyDown($event)" [class.searchClose]="searchText==''">
              <button type="submit" class="search-icon  " (click)="clearSearchText()" *ngIf="searchText"><i
                  class="fa fa-times icon"></i></button>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary searchfield-right btn-search" id="text-search" type="button"><i
                    class="fas fa-search search" (click)="searchGrid()"></i></button>
              </div>
            </div>
            <div class="p-1" style="margin-top: -4px;height: 46px;">
              <button class="btn btn-outline" style="border: solid 1px; border-radius: 5px;" id="text-search"
                type="button" (click)="deleteMultipleProjects()" [disabled]="!isSelectAll && !selectedDelete"><i
                  class="fas fa-trash"></i></button>
            </div>
          </div>
          <!---row loop-->
          <div *ngIf="contentType === 'Case Studies';else ictView" class="list" style="overflow-y:scroll;"
            infinite-scroll [infiniteScrollDistance]="distance" [infiniteScrollThrottle]="throttle"
            (scroll)="onScroll()">
            <div *ngIf="((allProjects && allProjects.length > 0) || isProjectsLoading);else showMessage">
              <div class="row p-3 m-0 border-bottom" *ngFor="let attachment of allProjects">
                <div class="col p-0">
                  <div class="row">
                    <div class="col-12 col-md-1 col-lg-1 text-truncate">
                      <div class="pr-2 mt-3">
                        <mat-checkbox color="primary" [checked]="findChecked(attachment.id) || isSelectAll"
                          (change)="addToDeleteList(attachment,$event)"></mat-checkbox>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 col-lg-3 text-truncate">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Project Name </span></div>
                        <div class=" text-truncate"><span class="heading_3" matTooltip="{{attachment.projectName}}"
                            placement="bottom">{{attachment.projectName}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-2 col-lg-2 text-truncate">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Project Manager</span></div>
                        <div class="text-truncate"><span class="heading_3" matTooltip="{{attachment.projectManager}}"
                            placement="bottom">{{attachment.projectManager}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 col-lg-3 text-truncate">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Sales Contact</span></div>
                        <div class="text-truncate"><span class="heading_3" matTooltip="{{attachment.bdContact}}"
                            placement="bottom">{{attachment.bdContact}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 col-lg-3 text-truncate">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Location</span></div>
                        <div class="text-truncate"><span class="heading_3" matTooltip="{{attachment.geography}}"
                            placement="bottom">{{attachment.geography}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-auto d-flex p-0 border-left">

                  <div class="buttons_column align-self-center  p-0">
                    <i *ngIf="permissions.canViewProject" class="fas fa-eye m-2" title="View"
                      (click)="navigate(attachment.id, true)">
                    </i>
                    <i *ngIf="permissions.canUpdateProject && (attachment.updatedBy === userEmail || !attachment.isLocked)"
                      title="Edit" (click)="navigate(attachment.id,false)" class="fas fa-edit  m-2"></i>
                    <i *ngIf="permissions.canDeleteProject" title="Delete" class="fas fa-trash-alt m-2"
                      (click)="deleteProject(attachment.id)" data-keyboard="false"></i>
                  </div>
                </div>
              </div>


            </div>

            <ng-template #showMessage>
              <p class="text-center">No projects found</p>
            </ng-template>
          </div>
          <div class="row">
            <ng-container *ngIf="contentType==='Case Studies'">
              <div class="col-3 d-flex">
                <div class="center mx-auto">
                  <p class="m-0 p-0">
                    <span *ngIf="projectCount && currentPage">
                      {{projectCount}}
                      records
                    </span>
                  </p>
                </div>
              </div>
            </ng-container>

          </div>

          <ng-template #ictView>
            <div *ngIf="((allProjects && allProjects.length > 0) || isProjectsLoading);else showMessage" class="list" style="overflow-y:scroll;"
              infinite-scroll [infiniteScrollDistance]="distance" [infiniteScrollThrottle]="throttle"
              (scroll)="onScrolled(contentType)">
              <div class="row p-3 m-0 border-bottom" *ngFor="let attachment of allProjects; let i=index;">
                <div class="col-11 p-0">
                  <div class="row">
                    <div class="col-12 col-md-1 col-lg-1 text-truncate">
                      <div class="pr-2 mt-3">
                        <mat-checkbox color="primary" [checked]="findChecked(attachment.id)"
                          (change)="addToDeleteList(attachment,$event)"></mat-checkbox>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 col-lg-3 text-truncate">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Deck Name </span></div>
                        <div class=" text-truncate"><span class="heading_3" matTooltip="{{attachment.projectName}}"
                            placement="bottom">{{attachment.projectName}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 col-lg-3 text-truncate">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Description</span></div>
                        <div class="text-truncate"><span class="heading_3" matTooltip="{{attachment.description}}"
                            placement="bottom">{{attachment.description}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 col-lg-3 text-truncate"
                      [ngClass]="{'col-md-2 col-lg-2':attachment.version}">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Purpose Of Usage</span></div>
                        <div class="text-truncate"><span class="heading_3" matTooltip="{{attachment.purposeOfUsage}}"
                            placement="bottom">{{attachment.purposeOfUsage}}</span></div>
                      </div>
                    </div>

                    <div class="col-12 col-md-1 col-lg-1 text-truncate" *ngIf="attachment.version">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Versions</span></div>
                        <div class="text-truncate"><span class="heading_3">{{attachment.version}} <i
                              *ngIf="attachment.version > 1" class="fas fa-angle-double-down mx-2"
                              [ngClass]="{'fa-angle-double-up':attachment.version}"
                              (click)="toggleShowVersions(i)"></i></span></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-1 d-flex p-0 border-left">

                  <div class="buttons_column align-self-center  p-0">
                    <i *ngIf="ictPermissions.canViewProject" class="fas fa-eye m-2 htgh" title="View"
                      (click)="navigateToICT(attachment.id , true)">
                    </i>
                    <i *ngIf="ictPermissions.canUpdateProject" title="Edit" (click)="editICTProject(attachment)"
                      class="fas fa-edit  m-2"></i>
                    <i *ngIf="ictPermissions.canApproveProject" title="View & Approve"
                      class="fas fa-check-circle m-2 approve" (click)="navigateToICT(attachment.id , false)"
                      data-keyboard="false"></i>
                    <i *ngIf="ictPermissions.canDeleteProject" title="Delete" class="fas fa-trash-alt m-2"
                      (click)="deleteICTProject(attachment.id)" data-keyboard="false"></i>
                  </div>
                </div>
                <div class="col-11 versions my-4 " *ngIf="attachment.showVersions">
                  <div class="row p-3 m-0 border-bottom" *ngFor="let version of attachment.versions">
                    <div class="col p-0">
                      <div class="row">
                        <div class="col-12 col-md-1 col-lg-1 text-truncate">
                          <div class="pr-2 mt-3">
                            <mat-checkbox color="primary" [checked]="findChecked(attachment.id)"
                              (change)="addToDeleteList(version,$event)"></mat-checkbox>
                          </div>
                        </div>
                        <div class="col-12 col-md-3 col-lg-3 text-truncate">
                          <div class="pr-2">
                            <div><span class="secondaryInfo">Project Name </span></div>
                            <div class=" text-truncate"><span class="heading_3" matTooltip="{{version.projectName}}"
                                placement="bottom">{{version.projectName}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-2 col-lg-2 text-truncate">
                          <div class="pr-2">
                            <div><span class="secondaryInfo">Project Manager</span></div>
                            <div class="text-truncate"><span class="heading_3" matTooltip="{{version.projectManager}}"
                                placement="bottom">{{version.projectManager}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-3 col-lg-3 text-truncate"
                          [ngClass]="{'col-md-2 col-lg-2':version.versionsCount}">
                          <div class="pr-2">
                            <div><span class="secondaryInfo">Sales Contact</span></div>
                            <div class="text-truncate"><span class="heading_3" matTooltip="{{version.bdContact}}"
                                placement="bottom">{{version.bdContact}}</span>
                            </div>
                          </div>
                        </div>
                        <div class=" pl-md-0 col-md-2 col-lg-2 text-truncate">
                          <div class="pr-2">
                            <div><span class="secondaryInfo">Location</span></div>
                            <div class="text-truncate"><span class="heading_3" matTooltip="{{version.geography}}"
                                placement="bottom">{{version.geography}}</span>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="col-auto d-flex p-0 border-left">

                      <div class="buttons_column align-self-center  p-0">
                        <i *ngIf="permissions.canViewProject" class="fas fa-eye m-2" title="View" (click)="navigate()">
                        </i>
                        <i *ngIf="permissions.canUpdateProject" title="Edit"
                          [routerLink]="['/project/ICT/editProject/',attachment.id]" class="fas fa-edit  m-2"></i>
                        <i *ngIf="permissions.canApproveProject" title="View & Approve"
                          class="fas fa-check-circle m-2 approve" (click)="navigate(attachment.id)"
                          data-keyboard="false"></i>
                        <i *ngIf="permissions.canDeleteProject" title="Delete" class="fas fa-trash-alt m-2"
                          (click)="deleteICTProject(attachment.id)" data-keyboard="false"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="row">
              <ng-container *ngIf="contentType!=='Case Studies'">
                <div class="col-3 d-flex">
                  <div class="center mx-auto">
                    <p class="m-0 p-0">
                      <span *ngIf="projectCount && currentPage">
                        {{projectCount}}
                        record
                      </span>
                    </p>
                  </div>
                </div>
              </ng-container>
              <!-- Pagination -->
              <div class="col-9" *ngIf="projectCount > size">
                <div class=" my-3 mr-3 floatRight">
                  <nav aria-label="Page navigation example">
                    <ul class="pagination justify-content-center" style="float: right;" *ngIf="pages">

                    </ul>
                  </nav>
                </div>
              </div>
            </div>

            <ng-template #showMessage>
              <p class="text-center">No projects found</p>
            </ng-template>
          </ng-template>

        </div>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->
<div #actions class="actions">
  <div>
    <i class="far fa-trash-alt whiteFont" (click)="deleteMultipleProjects()"></i>
  </div>
</div>

<!-- <div class="overlay" (click)="dismissSidebar()"></div> -->